var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DropdownStates } from '../types/DropdownStates';
import { KEY_CODES } from '../../../common/types/keyCodes';
/**
 * An object of keys to states and the fn to fire when these combinations match
 */
export var getDropdownInputKeyHandlers = function () {
    var _a, _b, _c, _d, _e, _f;
    return (_a = {},
        _a[KEY_CODES.ARROW_DOWN.key] = (_b = {},
            _b[DropdownStates.LIST_CLOSED] = function (_a) {
                var searchForValue = _a.searchForValue;
                return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                    return [2 /*return*/, searchForValue('')];
                }); });
            },
            _b[DropdownStates.LIST_OPEN] = function (_a) {
                var key = _a.key, updateHighlightedOptionIndex = _a.updateHighlightedOptionIndex;
                return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                    return [2 /*return*/, updateHighlightedOptionIndex(key)];
                }); });
            },
            _b),
        _a[KEY_CODES.ARROW_UP.key] = (_c = {},
            _c[DropdownStates.LIST_OPEN] = function (_a) {
                var key = _a.key, updateHighlightedOptionIndex = _a.updateHighlightedOptionIndex;
                return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                    return [2 /*return*/, updateHighlightedOptionIndex(key)];
                }); });
            },
            _c),
        _a[KEY_CODES.ENTER.key] = (_d = {},
            _d[DropdownStates.LIST_OPEN] = function (_a) {
                var highlightedOptionIndex = _a.highlightedOptionIndex, dropdownOptions = _a.dropdownOptions, setSelectedDropdownOption = _a.setSelectedDropdownOption;
                return __awaiter(void 0, void 0, void 0, function () {
                    var _b, error_1;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                _c.trys.push([0, 3, , 4]);
                                _b = highlightedOptionIndex !== null;
                                if (!_b) return [3 /*break*/, 2];
                                return [4 /*yield*/, setSelectedDropdownOption(dropdownOptions[highlightedOptionIndex])];
                            case 1:
                                _b = (_c.sent());
                                _c.label = 2;
                            case 2:
                                _b;
                                return [3 /*break*/, 4];
                            case 3:
                                error_1 = _c.sent();
                                console.error(error_1);
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                });
            },
            _d[DropdownStates.LIST_CLOSED] = function (_a) {
                var handleEnterOnInput = _a.handleEnterOnInput;
                return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                    return [2 /*return*/, handleEnterOnInput === null || handleEnterOnInput === void 0 ? void 0 : handleEnterOnInput()];
                }); });
            },
            _d),
        _a[KEY_CODES.TAB.key] = (_e = {},
            _e[DropdownStates.LIST_OPEN] = function (_a) {
                var highlightedOptionIndex = _a.highlightedOptionIndex, dropdownOptions = _a.dropdownOptions, setSelectedDropdownOption = _a.setSelectedDropdownOption;
                return __awaiter(void 0, void 0, void 0, function () {
                    var error_2;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                _b.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, setSelectedDropdownOption(dropdownOptions[highlightedOptionIndex])];
                            case 1:
                                _b.sent();
                                return [3 /*break*/, 3];
                            case 2:
                                error_2 = _b.sent();
                                console.error(error_2);
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
            _e),
        _a[KEY_CODES.DELETE.key] = (_f = {},
            _f[DropdownStates.LIST_CLOSED] = function (_a) {
                var selectedDropdownOption = _a.selectedDropdownOption, clearSelectedValue = _a.clearSelectedValue;
                return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
                    return [2 /*return*/, selectedDropdownOption && clearSelectedValue()];
                }); });
            },
            _f),
        _a);
};
//# sourceMappingURL=getDropdownInputKeyHandlers.js.map